import { data } from '../../svg/Coupon/data';
import { makeIcon } from '../makeIcon';

export const Coupon = makeIcon(data, 'coupon', 'Coupon');

export default Coupon;
